import { registerSW } from "virtual:pwa-register";

// A deployed build has been precached and its service worker has already taken
// control (skipWaiting + clientsClaim are baked into the generated worker), so
// this page is the last thing still running the old bundle. We deliberately do
// NOT reload on the spot: a long-open standalone window could be mid duel-entry.
// Instead we arm this flag and swap to the new build at the next moment that
// cannot interrupt anyone - the tab going to the background, or a route change.
let updatePending = false;

// Register the worker, keep checking for deploys, and arm the deferred reload.
// Call once at startup. Production only: the dev server runs no service worker
// (see vite.config.ts devOptions.enabled), so there is nothing to register or
// poll while developing.
export function registerForUpdates() {
  registerSW({
    immediate: true,
    // registerType "autoUpdate" would window.location.reload() the instant the
    // new worker activates; supplying onNeedReload hands that timing to us.
    onNeedReload() {
      // If the user is not looking, swap right away; otherwise wait for a safe
      // moment so we never yank them out of a form.
      if (document.hidden) window.location.reload();
      else updatePending = true;
    },
    onRegisteredSW(_swUrl, registration) {
      // workbox-window registers once and never re-checks on its own, so a
      // window left open for hours would never notice a deploy. Poll per minute; a
      // failed check (server briefly unreachable) is a no-op, not a rejection.
      if (!registration) return;
      setInterval(() => void registration.update().catch(() => {}), 60_000);
    },
  });

  // Safe moment: the tab is hidden (app backgrounded, screen locked, tab
  // switched). Reloading while hidden means the next time it is shown it is
  // already the new build, with no flash and no interrupted input.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden" && updatePending) {
      updatePending = false;
      window.location.reload();
    }
  });
}

// Safe moment: a route change. Wired from the router (see app.tsx) so a pending
// update still lands even if the user keeps the app foregrounded but moves
// between pages. We hard-navigate to the destination rather than reload the
// current URL, so the click lands on the page the user asked for, freshly served
// by the new worker. A no-op until an update is actually waiting.
export function applyUpdateOnNavigation(toHref: string) {
  if (!updatePending) return;
  updatePending = false;
  window.location.href = toHref;
}
